export default __webpack_public_path__ + "static/media/warning--arch-bridge--g1.5cc463ff.png";